import { ChevronLeft, ChevronRight } from 'lucide-react';
import ReactPaginate from 'react-paginate';

import { clsx } from 'clsx';

import { ICON_DEFAULT } from '@shared/constants/colors';
import { useAppSelector } from '@shared/hooks/redux';
import { PaginationData } from '@shared/types/pagination';
import { getViewPort } from '@shared/ui/ScreenSizeTracking';

import cls from './Pagination.module.scss';

type PaginationProps = {
  changePageNumber?: (number: number) => void;
  data: PaginationData;
  className?: string;
};

export const Pagination = ({ changePageNumber, data, className }: PaginationProps) => {
  const viewPort = useAppSelector(getViewPort);

  const changePageHandler = (num: number) => {
    if (changePageNumber) {
      changePageNumber(num);
      window.scrollTo({
        top: 0
      });
    }
  };

  const handlePageClick = (event: { selected: number }) => {
    if (changePageHandler) changePageHandler(event.selected + 1);
  };

  const nextPageHandler = () => {
    if (changePageHandler) changePageHandler(data?.page + 1);
  };

  const prevPageHandler = () => {
    if (changePageHandler) changePageHandler(data?.page - 1);
  };

  return (
    <div
      data-testid="pagination"
      aria-label={'Список страниц'}
      className={clsx(cls.wrap, className)}
    >
      <ReactPaginate
        breakLabel="..."
        nextLabel={
          data.page !== data.pageAll ? (
            <button
              aria-label={'Показать предыдущую страницу'}
              onClick={nextPageHandler}
              className={clsx(cls.next, cls.btn)}
            >
              <ChevronRight color={ICON_DEFAULT} />
            </button>
          ) : null
        }
        previousLabel={
          data.page !== 1 ? (
            <button
              aria-label={'Показать следующую страницу'}
              onClick={prevPageHandler}
              className={clsx(cls.prev, cls.btn)}
            >
              <ChevronLeft color={ICON_DEFAULT} />
            </button>
          ) : null
        }
        forcePage={data.page - 1}
        onPageChange={handlePageClick}
        pageRangeDisplayed={viewPort === 'mobile' ? 2 : 4}
        marginPagesDisplayed={1}
        pageCount={data.pageAll}
        renderOnZeroPageCount={null}
        breakLinkClassName={cls.dots}
        pageLinkClassName={cls.link}
        pageClassName={cls.item}
        activeClassName={cls.active}
        className={cls.pages}
      />
    </div>
  );
};
